import { create } from 'zustand';
import { IAppointmentDetailsSlideStore } from './types';
import type { TAppointmentCamel } from '@/types';

export const useAppointmentDetailsSlideStore =
  create<IAppointmentDetailsSlideStore>((set) => ({
    open: false,
    setOpen: (value: boolean) => {
      if (!value) {
        set({ activeTab: null });
      }
      set({ open: value });
    },
    activeTab: null,
    setActiveTab: (activeTab) => {
      set({ activeTab });
    },
    loading: false,
    selectedAppointment: null,
    setSelectedAppointment: (appointment: TAppointmentCamel | null) =>
      set(() => ({ selectedAppointment: appointment })),
  }));
